import { FormGroup } from '@angular/forms';

export const passwordPatternValidator = (rules: OLO.Common.IPasswordOptionsValidator = {}) => {
    return (control: FormGroup): OLO.Common.IValidators | null => {
        const defaults: OLO.Common.IPasswordOptionsValidator = {
            minLength: 6,
            upperCaseCount: 1,
            lowerCaseCount: 1,
            digitsCount: 1,
            specialCharsCount: 1,
            allowWhiteSpaces: false,
        };

        const opts: OLO.Common.IPasswordOptionsValidator = {
            ...defaults,
            ...rules,
        };

        const validators = [];

        if (opts.upperCaseCount) {
            validators.push(upperCaseValidators(opts.upperCaseCount));
        }

        if (opts.lowerCaseCount) {
            validators.push(lowerCaseValidators(opts.lowerCaseCount));
        }

        if (opts.digitsCount) {
            validators.push(digitsValidators(opts.digitsCount));
        }

        if (opts.specialCharsCount) {
            validators.push(specialCharsValidators(opts.specialCharsCount));
        }

        if (opts.allowWhiteSpaces === false) {
            validators.push(whiteSpacesValidators);
        }

        if (opts.minLength) {
            validators.push(lengthValidator(opts.minLength));
        }

        function lengthValidator(minLength: number) {
            return function (value) {
                if (!value || value.length < minLength) {
                    return {
                        error: 'minLength',
                        message: 'minimum length - ' + minLength + ' chars',
                        current: typeof value === 'string' ? value.length : 0,
                        messageShort: `${minLength} char${minLength > 1 ? 's' : ''} minimum`,
                    };
                }

                return null;
            };
        }

        function upperCaseValidators(minUpperCount: number) {
            return function (value) {
                let REGEXP = /[A-Z]/gm;
                let result = typeof value === 'string' ? value.match(REGEXP) : false;
                if (!result || result.length < minUpperCount) {
                    return {
                        error: 'minUppercaseCount',
                        message: 'minimum ' + minUpperCount + ' upper char',
                        messageShort: `${minUpperCount} uppercase`,
                    };
                }
                return null;
            };
        }

        function lowerCaseValidators(minLowerCount: number) {
            return function (value) {
                let REGEXP = /[a-z]/gm;
                let result = typeof value === 'string' ? value.match(REGEXP) : false;
                if (!result || result.length < minLowerCount) {
                    return {
                        error: 'minLowerCount',
                        message: 'minimum ' + minLowerCount + ' lower char',
                        messageShort: `${minLowerCount} lowercase`
                    };
                }
                return null;
            };
        }

        function digitsValidators(minDigitsCount: number) {
            return function (value) {
                let REGEXP = /[0-9]/gm;
                let result = typeof value === 'string' ? value.match(REGEXP) : false;
                if (!result || result.length < minDigitsCount) {
                    return {
                        error: 'minDigitsCount',
                        message: 'minimum ' + minDigitsCount + ' digit char',
                        messageShort: `${minDigitsCount} number${minDigitsCount > 1 ? 's' : ''}`
                    };
                }
                return null;
            };
        }

        function specialCharsValidators(minCount: number) {
            return function (value) {
                let REGEXP = /[\!\@\#\$\%\^\&\*\(\)\\\-\_\=\+\[\]\{\}\|\;\:\'\"\,\<\.\>\?\/]/gm;
                let result = typeof value === 'string' ? value.match(REGEXP) : false;
                if (!result || result.length < minCount) {
                    return {
                        error: 'specialCharsCount',
                        message: 'minimum ' + minCount + ' special char',
                        messageShort: `${minCount} special char${minCount > 1 ? 's' : ''}`
                    };
                }
                return null;
            };
        }

        function whiteSpacesValidators(value: string) {
            let REGEXP = /\s/gm;
            let result = typeof value === 'string' ? value.match(REGEXP) : false;
            if (result) {
                return {
                    error: 'whiteSpaces',
                    message: 'white spaces not allowed',
                    messageShort: `no spaces`
                };
            }
            return null;
        }

        const results = [];

        for (let i = 0, j = validators.length; i < j; i++) {
            const result = validators[i](control.value);
            if (result) {
                results.push(result);
            }
        }

        if (results.length) {
            return {
                passwordPattern: `${results.map(result => result.messageShort).join(', ')}`
            };
        }
        return null;
    };
};
